import { useState, useEffect } from 'react';
import { playerDevelopmentService, PlayerDevelopmentRecommendations } from '../services/playerDevelopmentService';

interface UsePlayerDevelopmentReturn {
  recommendations: PlayerDevelopmentRecommendations | null;
  loading: boolean;
  error: string | null;
}

export function usePlayerDevelopment(playerId: string | undefined, teamId: string | undefined): UsePlayerDevelopmentReturn {
  const [recommendations, setRecommendations] = useState<PlayerDevelopmentRecommendations | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!playerId || !teamId) return;

    let cancelled = false;
    const fetchRecommendations = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await playerDevelopmentService.getRecommendations(playerId, teamId);
        if (!cancelled) {
          setRecommendations(data);
        }
      } catch (err: any) {
        if (!cancelled) {
          if (err.response?.status === 404) {
            // No assessment data — not an error, just no data
            setRecommendations(null);
          } else {
            setError(err.response?.data?.error?.message || 'Failed to load development recommendations');
          }
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchRecommendations();
    return () => { cancelled = true; };
  }, [playerId, teamId]);

  return { recommendations, loading, error };
}
